import React from "react";
import { Route } from "react-router-dom";
import Account from "./common/Account";
import News from "./news/News";
import HomePage from "./news/HomePage";
import HomePagePublish from "./news/HomePagePublish";
import ConfigMember from "./system/ConfigMember";

export const HomeRoute = (
  <React.Fragment>
    <Route path="account" element={<Account />} />
    <Route path="news" element={<News />} />
    <Route path="homepage" element={<HomePage />} />
    <Route path="homepage/publish" element={<HomePagePublish />} />
    <Route path="config" element={<ConfigMember />} />
    <Route path="config/member" element={<ConfigMember />} />
  </React.Fragment>
);
